"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNonEmptyString = isNonEmptyString;
function isNonEmptyString(input) {
    return !!input?.trim().length;
}
//# sourceMappingURL=isNonEmptyString.js.map